import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import { isStartup, propTypes } from '../../util/types';
import { isUploadImageOverLimitError } from '../../util/errors';
import { isMobileSafari } from '../../util/userAgent';
import { findOptionsForSelectFilter } from '../../util/search';
import {
  FieldTextInput,
  Form,
  InfoTipForFields,
  IconDelete,
  EditListingWizardButtons,
  FieldSelect,
} from '../../components';

import arrayMutators from 'final-form-arrays';
import css from './EditListingPhotosForm.module.css';
import BackgroundPhoto from './BackgroundPhoto';
import PortfolioPhoto from './PortfolioPhoto';
import AddIcon from '@mui/icons-material/Add';

import BulletPointsField from '../../components/BulletPointsField/BulletPointsField';
import CountriesMultipleSelectField from '../../components/CountriesMultipleSelectField/CountriesMultipleSelectField';
import FilesField from './FilesField';
import config from '../../config';

import {
  getUserSubscriptionLevel,
  SUBSCRIPTION_LEVEL_2
} from '../../util/types';

const ACCEPT_IMAGES = 'image/*';

export class EditListingPhotosFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUploadRequested: false,
      showCrop: false,
      initialImages: [],
      showVideosForm: false,
      activeVideoIndex: 0,
    };
    this.onImageUploadHandler = this.onImageUploadHandler.bind(this);
    this.handleSubmitFile = this.handleSubmitFile.bind(this);
    this.submittedImages = [];
    this.isMobSaf = false;
  }

  componentDidMount() {
    this.isMobSaf = isMobileSafari();
    const { images } = this.props;

    if (this.compareImages()) {
      this.handleImages(images)
    }
  }

  componentDidUpdate(prevProps) {
    const { images } = this.props;

    if (this.compareImages()) {
      this.handleImages(images)
    }
  }

  imageIds(images) {
    return images &&
      images.length &&
      images
        .filter(image => image && (image.imageId || image.id && typeof image.id === 'object'))
        .map(image => image.imageId && image.imageId.uuid || image.id && image.id.uuid) || [];
  }

  handleImages(images) {
    const initialImages = this.imageIds(images);

    this.setState(
      { initialImages },
      // () => {
      //   form.change(
      //     'images',
      //     initialImages
      //   );
      // }
    )
  }

  onImageUploadHandler(file, imageKey) {
    const { onImageUpload, listing, handleSetFirstImage } = this.props

    if (file) {
      this.setState({ imageUploadRequested: true });
      onImageUpload({ id: `${Math.random().toFixed(4)}_${file.name}_${Date.now()}`, file, imageKey, listingId: listing?.id?.uuid })
        .then((res) => {
          this.setState({ imageUploadRequested: false });
          return res
        })
        .then((res) => {
          if (imageKey === "backgroundPhoto") {
            handleSetFirstImage({
              id: `${Math.random().toFixed(4)}_${file.name}_${Date.now()}`,
              file,
              imageId: res?.data?.data,
            })
          }
          return res
        })
        .catch(() => {
          this.setState({ imageUploadRequested: false });
        });
    }
  }

  compareImages() {
    const { images } = this.props;
    const { initialImages } = this.state;
    const prepearedImages = this.imageIds(images);

    return !isEqual(prepearedImages, initialImages);
  }

  handleSubmitFile(file, imageKey) {
    this.onImageUploadHandler(file, imageKey);
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        mutators={{ ...arrayMutators }}
        onImageUploadHandler={this.onImageUploadHandler}
        imageUploadRequested={this.state.imageUploadRequested}
        initialValues={{
          images: this.props.images,
          ...this.props.initialValues,
        }}
        render={formRenderProps => {
          const {
            className,
            fetchErrors,
            handleSubmit,
            images,
            imageUploadRequested,
            intl,
            invalid,
            onImageUploadHandler,
            onRemoveImage,
            disabled,
            ready,
            saveActionMsg,
            updated,
            updateInProgress,
            isClient,
            form,
            form: {
              mutators: { push },
            },
            values,
            listing,
            currentUser,
            firstImageFromState,
            isProvider,
            isDraftListing,
            onHandlePreviewPopup,
            onHandleCreateAndBublishListing
          } = formRenderProps;

          const { showCrop, showVideosForm, activeVideoIndex } = this.state;
          const noImagesAdded = images.length === 0;

          const imageRequiredMessage = intl.formatMessage({
            id: 'EditListingPhotosForm.imageRequired',
          });

          const qualificationsPlaceholder = intl.formatMessage({
            id: 'EditListingPhotosForm.qualificationsPlaceholder',
          });

          const associationsPlaceholder = intl.formatMessage({
            id: 'EditListingPhotosForm.associationsPlaceholder',
          });

          const { publishListingError, showListingsError, updateListingError, uploadImageError } =
            fetchErrors || {};
          const uploadOverLimit = isUploadImageOverLimitError(uploadImageError);

          let uploadImageFailed = null;

          if (uploadOverLimit) {
            uploadImageFailed = (
              <p className={css.error}>
                <FormattedMessage id="EditListingPhotosForm.imageUploadFailed.uploadOverLimit" />
              </p>
            );
          } else if (uploadImageError) {
            uploadImageFailed = (
              <p className={css.error}>
                <FormattedMessage id="EditListingPhotosForm.imageUploadFailed.uploadFailed" />
              </p>
            );
          }

          // NOTE: These error messages are here since Photos panel is the last visible panel
          // before creating a new listing. If that order is changed, these should be changed too.
          // Create and show listing errors are shown above submit button
          const publishListingFailed = publishListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPhotosForm.publishListingFailed" />
            </p>
          ) : null;
          const showListingFailed = showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPhotosForm.showListingFailed" />
            </p>
          ) : null;

          const submittedOnce = this.submittedImages.length > 0;
          // imgs can contain added images (with temp ids) and submitted images with uniq ids.
          const arrayOfImgIds = imgs =>
            imgs.map(i => (typeof i.id === 'string' ? i.imageId : i.id));
          const imageIdsFromProps = arrayOfImgIds(images);
          const imageIdsFromPreviousSubmit = arrayOfImgIds(this.submittedImages);
          const imageArrayHasSameImages = isEqual(imageIdsFromProps, imageIdsFromPreviousSubmit);
          const pristineSinceLastSubmit = submittedOnce && imageArrayHasSameImages;

          const submitReady = (updated && pristineSinceLastSubmit) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = disabled || submitInProgress || imageUploadRequested || ready;

          const classes = classNames(css.root, className);
          const publicData = listing?.attributes?.publicData;

          const imagesArray = !!values?.images?.length ? values.images : images;

          const firstImage = imagesArray.filter(
            img => typeof img.id === 'string' && img.id?.includes('backgroundPhoto-')
          );
          const newImages = imagesArray.filter(
            img => typeof img.id === 'string' && !img.id?.includes('backgroundPhoto-')
          );

          const savedImages = imagesArray.filter(img => !!img?.id?.uuid);
          const sortedImages = [...firstImage, ...savedImages, ...newImages];

          const onHandleAddVideo = () => {
            push(`videos`, { undefined }),
              this.setState({ showVideosForm: true }),
              this.setState({ activeVideoIndex: values?.videos?.length || 0 })
          }

          // provider
          const differentiationFromCompetitorsField = (
            <BulletPointsField
              id="differentiationFromCompetitors"
              name="differentiationFromCompetitors"
              label="Differentiation from competitors"
              tipId="EditListingDescriptionForm.differentiationTip"
            />
          );

          const associationTitleField = (
            <FieldTextInput
              id="associationTitle"
              name="associationTitle"
              className={css.infoField}
              type="text"
              label={'Is your company a member of any relevant Association?'}
              placeholder={'Enter association title'}
            />
          );
          const associationsField = (
            <FilesField
              fieldName='associations'
              label='Association that you are part of'
              placeholder={associationsPlaceholder}
              // tip={<InfoTipForFields tipId="EditListingDescriptionForm.documentTip" />}
              mutatorsPush={push}
              usePreviewIcon
            />
          );

          const qualificationTitleField = (
            <FieldTextInput
              id="qualificationTitle"
              name="qualificationTitle"
              className={css.infoFieldFile}
              type="text"
              label={'Do you or your company have any relevant qualification?'}
              placeholder={'Enter qualification title'}
            />
          );
          const qualificationsField = (
            <FilesField
              fieldName='qualifications'
              label='Qualification you have'
              placeholder={qualificationsPlaceholder}
              // tip={<InfoTipForFields tipId="EditListingDescriptionForm.documentTip" />}
              mutatorsPush={push}
              usePreviewIcon
            />
          );

          const docsUploadField = (
            <FilesField
              fieldName='files'
              label='Company documents'
              // isDocumentField
              tip={<InfoTipForFields tipId="EditListingDescriptionForm.documentTip" />}
              mutatorsPush={push}
              usePreviewIcon
            />
          );

          const backgroundPhoto = (
            <BackgroundPhoto
              key="BackgroundPhoto"
              showCrop={showCrop}
              isMobSaf={this.isMobSaf}
              form={form}
              publicData={publicData}
              images={sortedImages}
              intl={intl}
              imageUploadRequested={imageUploadRequested}
              onImageUploadHandler={onImageUploadHandler}
              onRemoveImage={onRemoveImage}
              handleSubmitFile={this.handleSubmitFile}
              handleCloseCropPopup={() => this.setState({ showCrop: false })}
              firstImageFromState={firstImageFromState}
            />
          );

          const portfolioPhoto = (
            <PortfolioPhoto
              key="PortfolioPhoto"
              showCrop={showCrop}
              isMobSaf={this.isMobSaf}
              form={form}
              publicData={publicData}
              images={sortedImages}
              intl={intl}
              imageUploadRequested={imageUploadRequested}
              onImageUploadHandler={onImageUploadHandler}
              onRemoveImage={onRemoveImage}
              handleSubmitFile={this.handleSubmitFile}
              handleCloseCropPopup={() => this.setState({ showCrop: false })}
              firstImageFromState={firstImageFromState}
            />
          );

          const uploadVideoField = (
            <>
              <h2 className={css.dynamicItemTitle}>
                <span>
                  <FormattedMessage id="EditListingPhotosForm.youtubeTitle" />
                  <InfoTipForFields tipId="EditListingPhotosForm.youtubeTitleTip" />
                </span>
                <AddIcon className={css.addButton} onClick={() => onHandleAddVideo()} />
              </h2>

              <FieldArray name={`videos`}>
                {({ fields }) => {
                  return fields.map((name, index) => {
                    const isSelected = activeVideoIndex === index;
                    return (
                      <>
                        {showVideosForm && (
                          <div key={`${name}-${index}`}>
                            <div
                              className={classNames(css.dynamicFieldWrapper, {
                                [css.dynamicFieldWrapperActive]: isSelected,
                              })}
                            >
                              <div
                                className={css.closeIconWrapper}
                                onClick={() => {
                                  fields.remove(index);
                                }}
                              >
                                <IconDelete />
                              </div>

                              <label htmlFor={`${name}.link`}>
                                <FormattedMessage id="EditListingPhotosForm.youtubeMessage" />
                              </label>
                              <Field
                                name={`${name}.link`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={intl.formatMessage({
                                  id: 'EditListingPhotosForm.youtubePlaceholder',
                                })}
                              />

                              <label htmlFor={`${name}.title`}>
                                <FormattedMessage id="EditListingPhotosForm.videoMessage" />
                              </label>
                              <Field
                                name={`${name}.title`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={intl.formatMessage({
                                  id: 'EditListingPhotosForm.videoPlaceholder',
                                })}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    );
                  });
                }}
              </FieldArray>
            </>
          );

          const phoneNumberField = (
            <FieldTextInput
              id="phoneNumber"
              name="phoneNumber"
              className={css.infoField}
              type="text"
              label={intl.formatMessage({
                id: 'EditListingDescriptionForm.phoneNumber',
              })}
              placeholder={'020 xxxx xxxx'}
            />
          );

          const supportedCountries = config.stripe.supportedCountries.map(c => c.code);
          const supportedCountriesOptions = supportedCountries.map(c => {
            return { label: intl.formatMessage({ id: `PayoutDetailsForm.countryNames.${c}` }), key: c };
          });

          const geographicalFocusField = (
            <CountriesMultipleSelectField
              name="geographicalFocus"
              id="geographicalFocus"
              label={intl.formatMessage({
                id: 'EditListingDescriptionForm.geographicalFocus',
              })}
              tipId="EditListingDescriptionForm.geographicalFocusTip"
              options={supportedCountriesOptions}
              placeholder="Select country"
            />
          );

          const operatingSinceOptions = findOptionsForSelectFilter(
            'operatingSince',
            config.custom.filters
          );

          const operatingSinceField = (
            <FieldSelect
              className={css.selectField}
              name={'operatingSince'}
              id={'operatingSince'}
              label={intl.formatMessage({
                id: 'EditListingDescriptionForm.numberOfYears',
              })}
              tipId='EditListingDescriptionForm.operatingSinceTip'
            >
              <option key={''} value={''} default hidden>
                {'Select an option'}
              </option>
              {operatingSinceOptions.map(c => (
                <option key={c.key} value={c.key}>
                  {c.label}
                </option>
              ))}
            </FieldSelect>
          );

          const companySizeOptions = findOptionsForSelectFilter('companySize', config.custom.filters);

          const companySizeField = (
            <FieldSelect
              className={css.selectField}
              name={'companySize'}
              id={'companySize'}
              label={intl.formatMessage({
                id: 'EditListingDescriptionForm.companySize',
              })}
            >
              <option key={''} value={''} default hidden>
                {'Select an option'}
              </option>
              {companySizeOptions.map(c => (
                <option key={c.key} value={c.key}>
                  {c.label}
                </option>
              ))}
            </FieldSelect>
          );

          const userSubscriptionLevel = getUserSubscriptionLevel(currentUser);

          const clientFields = [
            backgroundPhoto,
            portfolioPhoto,
            uploadImageFailed,
            docsUploadField,
            uploadVideoField,
            phoneNumberField,
            geographicalFocusField,
            operatingSinceField,
            companySizeField
          ];

          // const providerFields = userSubscriptionLevel >= SUBSCRIPTION_LEVEL_2 || (!!currentUser?.id?.uuid && isStartup(currentUser)) ? [
          //   backgroundPhoto,
          //   portfolioPhoto,
          //   uploadImageFailed,
          //   differentiationFromCompetitorsField,
          //   associationTitleField,
          //   associationsField,
          //   qualificationTitleField,
          //   qualificationsField,
          //   docsUploadField,
          //   uploadVideoField
          // ] : [
          //   backgroundPhoto,
          //   portfolioPhoto,
          //   uploadImageFailed,
          // ];

          const providerFields = [
            backgroundPhoto,
            portfolioPhoto,
            uploadImageFailed,
            differentiationFromCompetitorsField,
            associationTitleField,
            associationsField,
            qualificationTitleField,
            qualificationsField,
            docsUploadField,
            uploadVideoField
          ];

          let formFields = isClient ? clientFields : providerFields;

          return (
            <Form
              className={classes}
              onSubmit={e => {
                this.submittedImages = images;
                handleSubmit(e);
                setTimeout(() => {
                  this.setState({ showVideosForm: false })
                }, 1000)
              }}
            >
              {updateListingError ? (
                <p className={css.error}>
                  <FormattedMessage id="EditListingPhotosForm.updateFailed" />
                </p>
              ) : null}

              {formFields}

              {publishListingFailed}
              {showListingFailed}

              <EditListingWizardButtons
                disabled={!isClient && submitDisabled}
                inProgress={submitInProgress}
                ready={submitReady}
                saveActionMsg={saveActionMsg}
                isClient={isClient}
                isPhotosTab
                isDraftListing={isDraftListing}
                onHandlePreviewPopup={onHandlePreviewPopup}
                listingData={{ values, images }}
                listing={listing}
                values={values}
                imagesArray={imagesArray}
                onHandleCreateAndBublishListing={onHandleCreateAndBublishListing}
              />
            </Form>
          );
        }}
      />
    );
  }
}

EditListingPhotosFormComponent.defaultProps = { fetchErrors: null, images: [] };

EditListingPhotosFormComponent.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  images: array,
  intl: intlShape.isRequired,
  onImageUpload: func.isRequired,
  onUpdateImageOrder: func.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  onRemoveImage: func.isRequired,
};

export default compose(injectIntl)(EditListingPhotosFormComponent);
